import React, { Component } from "react";
import Palette from "./Palette";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icon from "./Icons";
import { l } from "../functions";
import { connect } from "react-redux";
import { copyIt } from "../core/redux/actions";
import { withStyles } from "@material-ui/styles";
import { Tooltip } from "@material-ui/core";

const mapStateToProps = (state) => {
  return {
    toCopy: state.rootReducer.toCopy || null,
  };
};

class PaletteSide_c extends Component {
  render() {
    const { closeEvent, title, children, paletteId, currentPaletteId } =
      this.props;
    return (
      <div
        id={paletteId}
        className={`palette-group ${
          paletteId === currentPaletteId ? "visible" : "hidden"
        }`}
        data-step-observe={`left-side-${paletteId}`}
      >
        {this.props.toCopy !== null && (
          <>
            <div
              className={`head ${
                this.props.toCopy !== null ? "" : "space-between"
              }`}
            >
              <h3 style={{ marginLeft: this.props.toCopy === null ? 0 : 16 }}>
                {l("Select page...")}
              </h3>
              <button
                className="gk-button gk-small gk-primary gk-danger"
                onClick={() => this.props.copyIt(null)}
              >
                <span>{l("Cancel copy")}</span>
              </button>
            </div>
          </>
        )}
        {paletteId === currentPaletteId && (
          <div className="body">{children}</div>
        )}
      </div>
    );
  }
}

export class PaletteSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentDrop: null,
      currentTab: "global",
    };
  }

  componentDidMount() {
    if (this.props.block) {
      this.setState({ currentDrop: null, currentTab: "designed_blocks" });
    }
  }

  componentWillReceiveProps({ currentPage }) {
    if (this.props.currentPage !== currentPage)
      this.setState({ currentDrop: null, currentTab: "global" });
  }

  dropDown = (current) => {
    if (this.state.currentDrop === current)
      this.setState({ currentDrop: null });
    else this.setState({ currentDrop: current });
  };

  render() {
    return (
      this.props.tabs &&
      this.props.tabs.length > 0 && (
        <div className="palette-tab">
          <div className="tabs-side">
            <h1 className="head" style={{ padding: 0 }}>
              {this.props.block ? "Blocks" : "Elements"}
            </h1>
            <ul>
              {this.props.tabs.map((tab, index) => {
                if (
                  tab.id === "designed_blocks" ||
                  tab.id === "global" ||
                  tab.id === this.props.currentPage ||
                  (this.props.currentPage.includes("product_") &&
                    tab.id === "product") ||
                  (this.props.currentPage.includes("upsell_") &&
                    tab.id === "upsell")
                )
                  return (
                    <li
                      key={index}
                      className={
                        tab.id === this.state.currentTab ? "active" : ""
                      }
                      onClick={() => {
                        this.setState({
                          currentTab: tab.id,
                          currentDrop: null,
                        });
                      }}
                    >
                      {tab.id == "designed_blocks"
                        ? l("My Blocks")
                        : l(tab.title)}
                    </li>
                  );
              })}
            </ul>
          </div>
          <div className="content-side">
            <div className="head" style={{ backgroundColor: "#191C3C" }}>
              <h1>{this.state.currentTab} </h1>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                  onClick={() => this.props.closeEvent()}
                >
                  <path
                    stroke="#A4A8C0"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5"
                    d="M18.118 17h-7.53M20 12.168H4.941M18.118 7h-7.53M6.51 14.823L4 11.913l2.51-2.894"
                  ></path>
                </svg>
              </div>
            </div>
            <ul className="tab-body">
              {this.props.tabs.map(
                (tab, index) =>
                  tab.id === this.state.currentTab && (
                    <li key={index}>
                      <ul className="palette-dropdown">
                        {tab.groups.map((group, index) => {
                          return (
                            <li key={index} className={"active"}>
                              <div
                                className="head"
                                onClick={() => this.dropDown(index)}
                              >
                                {l(group.title)}
                              </div>
                              {tab.id == "designed_blocks" && (
                                <div
                                  className={`body ${
                                    this.props.block ? "block" : ""
                                  }`}
                                >
                                  <Palette
                                    key={"palette-" + index}
                                    paletteElements={group.items}
                                    tabId={tab.id}
                                  />
                                </div>
                              )}
                              {tab.id != "designed_blocks" && (
                                <div className={`body elements`}>
                                  <Palette
                                    key={"palette-" + index}
                                    paletteElements={group.items}
                                    tabId={tab.id}
                                  />
                                </div>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  )
              )}
            </ul>
          </div>
        </div>
      )
    );
  }
}

class DefaultSection_c extends Component {
  render() {
    return (
      <div className="palette-section">
        {this.props.title && <h5>{l(this.props.title)}</h5>}
        {this.props.description && (
          <div className="warning-message">{l(this.props.description)}</div>
        )}
        {this.props.children}
      </div>
    );
  }
}
const CustomToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#191C3C",
    color: "#fff",
    padding: "0.5rem 1rem",
    fontSize: "0.9rem",
    marginLeft: 24,
    borderRadius: 8,
  },
  arrow: {
    color: "#191C3C",
  },
}))(Tooltip);

class PaletteIcon_c extends Component {
  render() {
    const { title, onClick, paletteId, currentPaletteId, icon } = this.props;
    return (
      <CustomToolTip arrow title={title} placement="right">
        <div
          className={`icon ${paletteId === currentPaletteId ? "active" : ""}`}
          onClick={() => onClick(paletteId)}
          data-step={paletteId}
        >
          {(Array.isArray(icon) && <FontAwesomeIcon icon={icon} />) || (
            // <div className="icon-container">
            //   <Icon icon={icon} />
            // </div>
            <Icon icon={icon} />
          )}
          {/* <span className="label">{l(title)}</span> */}
        </div>
      </CustomToolTip>
    );
  }
}

export class AddNew extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="addnew">
        <button onClick={() => this.props.onClick("blocks")}>Blocks</button>
        <button onClick={() => this.props.onClick("elements")}>Elements</button>
      </div>
    );
  }
}

export const PaletteSide = connect(mapStateToProps, { copyIt })(PaletteSide_c);
export const DefaultSection = connect(mapStateToProps)(DefaultSection_c);
export const PaletteIcon = connect(mapStateToProps)(PaletteIcon_c);
